import Link from "next/link";
import RichText from "../../RichText";
import { Page, PreviewServiceBlock } from "@/payload-types";

type ContentFromSelectedPage = NonNullable<
  PreviewServiceBlock["selectedPages"]
>[number];

export default function Service({
  service,
}: {
  service: ContentFromSelectedPage;
}) {
  const pageService = service.page as Page;

  const breadcrumb = pageService.breadcrumbs?.find(
    (f) => f.label == pageService.title,
  )?.url;

  return (
    <div className="relative h-fit px-5 py-2 text-gray-900 hover:rounded-lg hover:bg-slate-100 hover:text-slate-900">
      <dt className="text-base font-semibold leading-7 text-gray-900">
        <Link
          href={breadcrumb ? breadcrumb : `/${(service.page as Page).slug}`}
          className="after:absolute after:inset-0"
        >
          {(service.page as Page).title}
        </Link>
      </dt>
      <dd className="mt-1 text-base leading-7 text-gray-600">
        {service.pageRichText && <RichText data={service.pageRichText} />}
        <div className="flex justify-end">
          <span>En savoir plus →</span>
        </div>
      </dd>
    </div>
  );
}
